import { useEffect } from 'react';

import patternValidators from 'helpers/validators/pattern-validators';
import { useForm, useWatch } from 'react-hook-form';

import { Button, Input, InputGroup, Select } from 'components/FormComponents';

import { AnimatedModal } from '../../../../components/AnimatedModal/AnimatedModal';
import styles from './NewUserModal.module.scss';

export const NewUserModal = ({
  visible,
  roles,
  teams,
  onSubmit = () => {},
  onClose = () => {},
}) => {
  const {
    register,
    control,
    reset,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({ mode: 'onChange' });

  const teamIdValue = useWatch({ control, name: 'team_id' });
  const roleIdValue = useWatch({ control, name: 'role_id' });
  const emailError = errors?.email?.message || errors?.email?.type;

  useEffect(() => {
    if (!visible) reset();
  }, [visible, reset]);

  return (
    <AnimatedModal visible={visible} onClose={onClose} className={styles.root} title="Invite User">
      <form data-testid="invite-user-form" onSubmit={handleSubmit(onSubmit)}>
        <InputGroup title="First Name">
          <Input
            name="first_name"
            dataTestId="invite-user-first-name-input"
            placeholder="John"
            register={register}
            validators={{ required: true }}
            error={errors?.first_name?.type}
            inputProps={{ tabIndex: 1 }}
          />
        </InputGroup>
        <InputGroup title="Last Name">
          <Input
            name="last_name"
            dataTestId="invite-user-last-name-input"
            placeholder="Doe"
            register={register}
            validators={{ required: true }}
            error={errors?.last_name?.type}
            inputProps={{ tabIndex: 2 }}
          />
        </InputGroup>
        <InputGroup title="Email">
          <Input
            name="email"
            dataTestId="invite-user-email-input"
            placeholder="john@checkmate.tech"
            register={register}
            validators={{ required: true, ...patternValidators.email }}
            error={emailError}
            inputProps={{ tabIndex: 3 }}
          />
        </InputGroup>
        <InputGroup title="Contact Number">
          <Input
            name="contact_number"
            dataTestId="invite-user-contact-number-input"
            placeholder="+64 021 026-052"
            register={register}
            inputProps={{ tabIndex: 4 }}
          />
        </InputGroup>
        <InputGroup title="Add to team">
          <Select
            name="team_id"
            dataTestId="invite-user-team-select"
            placeholder="Product"
            register={register}
            value={teamIdValue}
            useDefault>
            {teams.map(team => (
              <Select.Item
                key={team.id}
                value={team.id}
                testId={'invite-user-team-option-' + team.name}>
                {team.name}
              </Select.Item>
            ))}
          </Select>
        </InputGroup>
        <InputGroup title="Add to role">
          <Select
            name="role_id"
            dataTestId="invite-user-role-select"
            placeholder="Manager"
            register={register}
            value={roleIdValue}
            useDefault>
            {roles.map(role => (
              <Select.Item
                key={role.id}
                value={role.id}
                testId={'invite-user-role-option-' + role.name}>
                {role.name}
              </Select.Item>
            ))}
          </Select>
        </InputGroup>
        <Button
          submit
          disabled={!isValid}
          className={styles.button}
          dataTestId="invite-user-submit-button">
          Invite
        </Button>
      </form>
    </AnimatedModal>
  );
};
